module.exports = __webpack_public_path__ + "assets/img/paid.57ed188d.png";